<template>
  <div>
    <slot :getDataField="getDataField" :getFilteredDataField="getFilteredDataField">
      <div class="single container-max page-content theme">
        <div class="row position-relative grid-wrap">
          <div class="col-12 col-lg mt-5 grid-1">
            <slot name="image-carousel"></slot>
            <!-- Hinweise zu Artikelstatus -->
            <div class="stoerer-wrapper">
              <template v-if="currentVariation.variationProperties && currentVariation.variationProperties.length">
                <template v-for="variationGroup in currentVariation.variationProperties">
                  <template v-for="prop in variationGroup.properties">
                    <div
                      v-if="prop.values && prop.values.value"
                      v-show="prop.id === 12 || prop.id === 13 || prop.id === 14 || prop.id === 2"
                      :key="prop.id"
                      :class="{
                        onlineonly: prop.id === 12,
                        storeonly: prop.id === 13,
                        temp: prop.id === 14,
                        ads: prop.id === 2,
                      }"
                    >
                      <span v-if="prop.id === 12">{{ $translate("stabiloVueTheme::Single.OnlineOnly") }}</span>
                      <span v-else-if="prop.id === 13">{{ $translate("stabiloVueTheme::Single.StoreOnly") }}</span>
                      <span v-else-if="prop.id === 14">{{ $translate("stabiloVueTheme::Single.TempOnly") }}</span>
                      <span v-else-if="prop.id === 2">{{ $translate("stabiloVueTheme::Single.AdsOnly") }}</span>
                    </div>
                  </template>
                </template>
              </template>
            </div>
          </div>

          <div class="col-12 col-lg mt-md-5 grid-2">
            <div>
              <h1 class="h2 title font-weight-bold font-heading" v-if="currentVariation.variation.name.length > 0" data-testing="item-name"><span v-html="currentVariation.variation.name"></span></h1>
              <h1 class="h2 title font-weight-bold font-heading" v-else><span v-html="currentVariation.texts.name1" data-testing="item-name"></span></h1>

              <div class="allg-infos d-flex flex-column flex-md-row align-items-start justify-content-start justify-content-md-start align-items-md-center">
                <div class="feedback-wrap d-flex align-items-center mb-1 mb-md-0" v-if="currentVariation.item.feedbackCount > 2">
                  <a href="#feedback-anchor">
                    <slot name="before-price"></slot>
                    <span class="text-secondary feedback-count">({{ currentVariation.item.feedbackCount }})</span>
                  </a>
                </div>

                <div v-if="currentVariation.item.feedbackCount > 2" class="d-none d-md-block">&nbsp;/&nbsp;</div>
                <div class="articlenumber mb-1 mb-md-0">
                  <span class="headline">{{ $translate("Ceres::Template.singleItemNumber") }} </span>
                  <span>{{ currentVariation.variation.number }}</span>
                </div>
                <div class="d-none d-md-block">&nbsp;/&nbsp;</div>
                <div class="articlenumber mb-1 mb-md-0">
                  <span class="headline">{{ $translate("stabiloVueTheme::Single.ManuItemId") }}: </span>
                  <span>{{ currentVariation.variation.model }}</span>
                </div>
                <div class="d-none d-md-block">&nbsp;/&nbsp;</div>

                <div class="producertag" v-if="currentVariation.item.manufacturer && currentVariation.item.manufacturer.externalName">
                  {{ $translate("stabiloVueTheme::Single.Brand") }}:
                  <a v-if="currentVariation.item.manufacturer.url" :href="currentVariation.item.manufacturer.url" class="">
                    <span v-html="currentVariation.item.manufacturer.externalName"></span>
                  </a>
                  <template v-else>
                    <span v-html="currentVariation.item.manufacturer.externalName"></span>
                  </template>
                </div>
              </div>
              <div class="singleitem-links">
                <slot name="single-bread"></slot>
              </div>
              <!-- Variation -->
              <div class="mb-3" v-if="attributes.length || Object.keys(units).length">
                <variation-select></variation-select>
              </div>
              <!-- /Variation -->

              <!-- Item Bundle -->
              <item-bundle
                v-if="currentVariation.variation.bundleType === 'bundle'"
                :bundle-type="currentVariation.variation.bundleType"
                :bundle-components="currentVariation.bundleComponents"
              ></item-bundle>
              <!-- /Item Bundle -->

              <div v-if="currentVariation.filter.isSalable && variationGroupedProperties.length">
                <order-property-list></order-property-list>
              </div>

              <graduated-prices></graduated-prices>

              <div class="d-flex price-wrap align-items-end mb-3">
                <item-price :show-cross-price="isRecommendedPriceActive" :show-net-prices="showNetPrices" :shipping-preview="activeShippingPreview"></item-price>
              </div>

              <slot name="after-price"></slot>

              <!-- Anzeige der Lieferzeit: BEGIN -->
              <span v-if="currentVariation.variation.availability.id <= 4" class="d-block translation">
                {{ $translate("stabiloVueTheme::Single.AvailabilityID14") }}
              </span>
              <span v-else-if="currentVariation.variation.availability.id == 10" class="d-block translation">
                {{ $translate("stabiloVueTheme::Single.AvailabilityID10") }}
              </span>
              <span v-else class="d-block translation">
                {{ $translate("stabiloVueTheme::Single.AvailabilityID59") }}
              </span>
              <div v-if="hasSpeditionDelivery" class="eig-availability">{{ $translate("stabiloVueTheme::Single.DeliveryTimeSpedition") }}</div>
              <div
                v-else-if="currentVariation.variation.availability && currentVariation.variation.availability.names && currentVariation.variation.availability.names.name"
                class="standard-availability"
              >
                {{ currentVariation.variation.availability.names.name }}
              </div>
              <div
                v-if="currentVariation.variation.availability"
                :class="'availability custom_wiederlieferbar-plugin-modal font-weight-bold availability-' + currentVariation.variation.availability.id"
              >
                <div v-if="currentVariation.variation.availability.id == 10">
                  <!-- Button trigger modal -->
                  <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#verfuegbarkeitsModal">
                    {{ $translate("stabiloVueTheme::Single.NotifyOnAvailability") }}
                  </button>
                  <!-- Modal Slot -->
                  <slot name="verfuegbarkeits-modal"></slot>
                </div>
              </div>

              <!-- Anzeige der Lieferzeit: END -->

              <template v-if="currentVariation.variationProperties && currentVariation.variationProperties.length">
                <template v-for="variationGroup in currentVariation.variationProperties">
                  <template v-for="prop in variationGroup.properties">
                    <div v-if="prop.id === 2" class="advertism mt-3">
                      <div class="alert alert-warning" role="alert">
                        {{ $translate("stabiloVueTheme::Single.WerbungText") }}
                      </div>
                    </div>
                    <template v-if="prop.id === 13">
                      <!-- Marktverfuegbarkeit: START -->
                      <div class="verfuegbarkeit_markt">
                        <i aria-hidden="true" class="fa fa-shopping-basket"></i>
                        <a href="/baumaerkte/" target="_blank">{{ $translate("stabiloVueTheme::Single.MarketAvailabilityLink") }}</a>
                        <br />
                        <span>{{ $translate("stabiloVueTheme::Single.MarketAvailabilityText") }}</span>
                      </div>
                      <!-- Marktverfuegbarkeit: END -->
                    </template>
                  </template>
                </template>
              </template>

              <div class="row add-wish-wrap my-4">
                <div class="w-100">
                  <slot name="before-add-to-basket"></slot>
                </div>

                <div v-if="currentVariation.item.itemType === 'set'" class="alert alert-info w-100">
                  {{ $translate("Ceres::Template.singleItemSetInfo") }}
                </div>

                <div v-else class="col-10 col-xl-11">
                  <div ref="buyboxCtaSentinel" aria-hidden="true"></div>
                  <div ref="buyboxCta">
                    <add-to-basket
                      :variation-id="currentVariation.variation.id"
                      :is-salable="!!currentVariation.filter && currentVariation.filter.isSalable"
                      :has-children="!!currentVariation.filter && currentVariation.filter.hasActiveChildren"
                      :interval-quantity="currentVariation.variation.intervalOrderQuantity || 1"
                      :minimum-quantity="currentVariation.variation.minimumOrderQuantity"
                      :maximum-quantity="
                        !!currentVariation.variation.maximumOrderQuantity && currentVariation.variation.maximumOrderQuantity > 0 ? currentVariation.variation.maximumOrderQuantity : null
                      "
                      :order-properties="
                        currentVariation.properties.filter(function(prop) {
                          return prop.property.isOderProperty;
                        })
                      "
                      :has-order-properties="currentVariation.hasOrderProperties"
                      :has-required-order-property="currentVariation.hasRequiredOrderProperty"
                      :use-large-scale="false"
                      :show-quantity="true"
                      :item-url="currentVariation | itemURL"
                      :is-variation-selected="isVariationSelected && currentVariation.filter.isSalable"
                      :has-price="currentVariation | hasItemDefaultPrice"
                    >
                    </add-to-basket>
                  </div>
                </div>

                <div class="col-2 col-xl-1 wish px-0" v-if="isWishListEnabled">
                  <add-to-wish-list :variation-id="currentVariation.variation.id"></add-to-wish-list>
                </div>

                <div class="w-100">
                  <slot name="after-add-to-basket"></slot>
                </div>
              </div>

              <!-- EnergieLabel -->
              <div v-if="energyLabelImage" class="energy-label my-3">
                <img :src="energyLabelImage" :alt="energyLabelValue" style="max-width: 80px; cursor: pointer;" @click="showEnergyLabelModal = true" />
                <!-- Modal -->
                <div v-if="showEnergyLabelModal" class="modal fade show" tabindex="-1" style="display: block; background: rgba(0,0,0,0.5);" @click.self="showEnergyLabelModal = false">
                  <div class="modal-dialog modal-lg modal-dialog-centered">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h5 class="modal-title" id="energyLabelModalLabel">{{ $translate("stabiloVueTheme::EnergyLabel.EnergyLabelModalTitle") }}</h5>
                        <button type="button" class="close" @click="showEnergyLabelModal = false">
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div class="modal-body text-center">
                        <img :src="energyLabelModalImage" alt="EnergieLabel" style="max-width: 100%;" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- /EnergieLabel -->

              <p class="single-description" v-if="isShortDescriptionActive && currentVariation.texts.shortDescription !== ''" v-html="currentVariation.texts.shortDescription"></p>
              <!-- ./ITEM DETAIL -->

              <slot name="additional-content-after-add-to-basket"></slot>

              <slot name="additional-content-after-vat"></slot>
              <!-- END SINGLEITEM_DETAILS -->
            </div>
          </div>

          <div class="col-12 col-lg grid-4">
            <!-- ITEM DESCRIPTION -->

            <div class="accordion" id="itemAccordion">
              <div class="card">
                <div class="card-header d-flex justify-content-between align-items-center px-0" @click="toggleAccordion('description', $event)">
                  <h2 class="mb-0">
                    <button class="btn btn-link pl-0 font-weight-bold" type="button">
                      <img :src="$translate('stabiloVueTheme::Single.ProductDescriptionIcon')" :alt="$translate('Ceres::Template.singleItemDescription')" class="img-fluid mr-2" />
                      {{ $translate("Ceres::Template.singleItemDescription") }}
                    </button>
                  </h2>
                  <i class="fa" :class="isAccordionOpen('description') ? 'fa-minus' : 'fa-plus'" aria-hidden="true"></i>
                </div>
                <div v-show="isAccordionOpen('description')" class="card-body px-0">
                  <div class="my-4" v-html="currentVariation.texts.description"></div>
                </div>
              </div>
              <div class="card" v-if="isTechnicalDataTabActive">
                <div class="card-header d-flex justify-content-between align-items-center px-0" @click="toggleAccordion('technical', $event)">
                  <h2 class="mb-0">
                    <button class="btn btn-link pl-0 font-weight-bold" type="button">
                      <img :src="$translate('stabiloVueTheme::Single.techDataIcon')" :alt="$translate('Ceres::Template.singleItemTechnicalData')" class="img-fluid mr-2" />
                      {{ $translate("Ceres::Template.singleItemTechnicalData") }}
                    </button>
                  </h2>
                  <i class="fa" :class="isAccordionOpen('technical') ? 'fa-minus' : 'fa-plus'" aria-hidden="true"></i>
                </div>
                <div v-show="isAccordionOpen('technical')" class="card-body px-0">
                  <div class="my-4" v-html="currentVariation.texts.technicalData"></div>
                </div>
              </div>
              <div class="card">
                <div class="card-header d-flex justify-content-between align-items-center px-0" @click="toggleAccordion('assessments', $event)">
                  <h2 class="mb-0">
                    <button class="btn btn-link pl-0 font-weight-bold" type="button">
                      <img :src="$translate('stabiloVueTheme::Single.moreDetailsIcon')" alt="weitere Details" class="img-fluid mr-2" />
                      {{ $translate("stabiloVueTheme::Single.moreDetailsText") }}
                    </button>
                  </h2>
                  <i class="fa" :class="isAccordionOpen('assessments') ? 'fa-minus' : 'fa-plus'" aria-hidden="true"></i>
                </div>
                <div v-show="isAccordionOpen('assessments')" class="card-body px-0">
                  <div class="my-4">
                    <table class="table table-striped table-hover table-sm">
                      <tbody>
                        <tr v-if="itemConfig.includes('item.id') || itemConfig.includes('all')">
                          <td>{{ $translate("Ceres::Template.singleItemId") }}</td>
                          <td>{{ currentVariation.item.id }}</td>
                        </tr>

                        <tr v-if="currentVariation.item.condition && currentVariation.item.condition.names.name !== '' && (itemConfig.includes('item.condition') || itemConfig.includes('all'))">
                          <td>{{ $translate("Ceres::Template.singleItemCondition") }}</td>
                          <td>{{ currentVariation.item.condition.names.name }}</td>
                        </tr>

                        <tr v-if="itemConfig.includes('item.age_rating') || itemConfig.includes('all')">
                          <td>{{ $translate("Ceres::Template.singleItemAge") }}</td>
                          <td>{{ currentVariation.item.ageRestriction | ageRestriction }}</td>
                        </tr>

                        <tr v-if="currentVariation.variation.externalId !== '' && (itemConfig.includes('item.external_id') || itemConfig.includes('all'))">
                          <td>{{ $translate("Ceres::Template.singleItemExternalVariationId") }}</td>
                          <td>{{ currentVariation.variation.externalId }}</td>
                        </tr>

                        <tr v-if="currentVariation.variation.model !== '' && (itemConfig.includes('item.variation_model') || itemConfig.includes('all'))">
                          <td>{{ $translate("Ceres::Template.singleItemModel") }}</td>
                          <td>{{ currentVariation.variation.model }}</td>
                        </tr>

                        <tr
                          v-if="
                            currentVariation.filter.hasManufacturer &&
                              currentVariation.item.manufacturer.externalName !== '' &&
                              (itemConfig.includes('item.manufacturer') || itemConfig.includes('all'))
                          "
                        >
                          <td>{{ $translate("Ceres::Template.singleItemManufacturer") }}</td>
                          <td>{{ currentVariation.item.manufacturer.externalName }}</td>
                        </tr>

                        <tr
                          v-if="
                            currentVariation.item.producingCountry &&
                              currentVariation.item.producingCountry.names.name !== '' &&
                              (itemConfig.includes('item.producerCountry') || itemConfig.includes('all'))
                          "
                        >
                          <td>{{ $translate("Ceres::Template.singleItemManufacturingCountry") }}</td>
                          <td>{{ currentVariation.item.producingCountry.names.name }}</td>
                        </tr>

                        <tr v-if="currentVariation.unit && (itemConfig.includes('item.variationBase_content') || itemConfig.includes('all'))">
                          <td>{{ $translate("Ceres::Template.singleItemContent") }}</td>
                          <td>{{ currentVariation.unit.content }} {{ currentVariation.unit.names.name }}</td>
                        </tr>

                        <tr v-if="currentVariation.variation.weightG !== '' && (itemConfig.includes('item.weightG') || itemConfig.includes('all'))">
                          <td>{{ $translate("Ceres::Template.singleItemWeight") }}</td>
                          <td>{{ currentVariation.variation.weightG }} g</td>
                        </tr>

                        <tr v-if="currentVariation.variation.weightNetG !== '' && (itemConfig.includes('item.weightNetG') || itemConfig.includes('all'))">
                          <td>{{ $translate("Ceres::Template.singleItemNetWeight") }}</td>
                          <td>{{ currentVariation.variation.weightNetG }} g</td>
                        </tr>

                        <tr v-if="itemConfig.includes('item.variation_dimensions') || itemConfig.includes('all')">
                          <td>{{ $translate("Ceres::Template.singleItemDimensions") }}</td>
                          <td>
                            <span>{{ currentVariation.variation.lengthMM }}</span
                            >&times;<!--
                                                  --><span>{{ currentVariation.variation.widthMM }}</span
                            >&times;<!--
                                                  --><span>{{ currentVariation.variation.heightMM }}</span> mm
                          </td>
                        </tr>

                        <tr v-if="currentVariation.variation.customsTariffNumber !== '' && (itemConfig.includes('variation.customs_tariff_number') || itemConfig.includes('all'))">
                          <td>{{ $translate("Ceres::Template.singleItemCustomsTariffNumber") }}</td>
                          <td>{{ currentVariation.variation.customsTariffNumber }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <!-- singleitem-produktdatenblatt: START -->
                  <div class="singleitem-produktdatenblatt">
                    <template v-for="variationGroups in currentVariation.variationProperties">
                      <template v-for="variationProperty in variationGroups.properties">
                        <a
                          v-if="variationProperty.id === 44 && variationProperty.values && variationProperty.values.value"
                          :href="variationProperty.values.value"
                          target="_blank"
                          class="text-dark mb-2 d-block"
                          v-html="$translate('stabiloVueTheme::Single.ProductDataSheet')"
                        ></a>
                      </template>
                    </template>
                  </div>
                  <!-- singleitem-produktdatenblatt: END -->

                  <!-- singleitem-bedienungsanleitung: START -->
                  <div class="singleitem-produktdatenblatt">
                    <template v-for="variationGroups in currentVariation.variationProperties">
                      <template v-for="variationProperty in variationGroups.properties">
                        <a
                          v-if="variationProperty.id === 143 && variationProperty.values && variationProperty.values.value"
                          :href="variationProperty.values.value"
                          target="_blank"
                          class="text-dark mb-2 d-block"
                          v-html="$translate('stabiloVueTheme::Single.Manual')"
                        ></a>
                      </template>
                    </template>
                  </div>
                  <!-- singleitem-bedienungsanleitung: END -->
                </div>
              </div>

              <div class="card" v-if="isManufacturerTabShown">
                <div class="card-header d-flex justify-content-between align-items-center px-0" @click="toggleAccordion('manufacturer', $event)">
                  <h2 class="mb-0">
                    <button class="btn btn-link pl-0 font-weight-bold" type="button">
                      <img :src="$translate('stabiloVueTheme::Single.EuResponsibleIcon')" :alt="$translate('Ceres::Template.singleItemManufacturer')" class="img-fluid mr-2" />
                      {{ $translate("stabiloVueTheme::Single.EuResponsibleHeadline") }}
                    </button>
                  </h2>
                  <i class="fa" :class="isAccordionOpen('manufacturer') ? 'fa-minus' : 'fa-plus'" aria-hidden="true"></i>
                </div>
                <div v-show="isAccordionOpen('manufacturer')" class="card-body px-0">
                  <div class="my-4">
                    <div class="p-0">
                      <span>{{ currentVariation.item.manufacturer.name }}</span>
                    </div>

                    <div class="p-0">
                      <span>{{ currentVariation.item.manufacturer.legalName }}</span>
                    </div>

                    <div class="p-0">
                      <span>{{ currentVariation.item.manufacturer.street }}</span>
                      <span>{{ currentVariation.item.manufacturer.houseNo }}</span>
                    </div>

                    <div class="p-0">
                      <span>{{ currentVariation.item.manufacturer.postcode }}</span>
                      <span>{{ currentVariation.item.manufacturer.town }}</span>
                      <span v-if="currentVariation.item.manufacturer.countryObject">
                        {{ currentVariation.item.manufacturer.countryObject.name }}
                      </span>
                    </div>

                    <div class="p-0">
                      <span>{{ currentVariation.item.manufacturer.email }}</span>
                    </div>

                    <div class="p-0">
                      <span>{{ currentVariation.item.manufacturer.url }}</span>
                    </div>

                    <div class="p-0">
                      <span>{{ currentVariation.item.manufacturer.phoneNumber }}</span>
                    </div>

                    <div class="p-0">
                      <span>{{ currentVariation.item.manufacturer.faxNumber }}</span>
                    </div>

                    <div class="p-0">
                      <span>{{ currentVariation.item.manufacturer.contactUrl }}</span>
                    </div>
                  </div>
                  <div class="mb-4">
                    <div class="p-0">
                      <span>{{ currentVariation.item.manufacturer.responsibleName }}</span>
                    </div>
                    <div class="p-0">
                      <span>{{ currentVariation.item.manufacturer.responsibleStreet }}</span>
                      <span>{{ currentVariation.item.manufacturer.responsibleHouseNo }}</span>
                    </div>
                    <div class="p-0">
                      <span>{{ currentVariation.item.manufacturer.responsiblePostCode }}</span>
                      <span>{{ currentVariation.item.manufacturer.responsibleTown }}</span>
                      <span v-if="currentVariation.item.manufacturer.responsibleCountryObject">
                        {{ currentVariation.item.manufacturer.responsibleCountryObject.name }}
                      </span>
                    </div>
                    <div class="p-0">
                      <span>{{ currentVariation.item.manufacturer.responsibleEmail }}</span>
                    </div>
                    <div class="p-0">
                      <span>{{ currentVariation.item.manufacturer.responsiblePhoneNo }}</span>
                    </div>
                    <div class="p-0">
                      <span>{{ currentVariation.item.manufacturer.responsibleContactUrl }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card" v-if="disposalText">
                <div class="card-header d-flex justify-content-between align-items-center px-0" @click="toggleAccordion('disposal', $event)">
                  <h2 class="mb-0">
                    <button class="btn btn-link pl-0 font-weight-bold" type="button">
                      <img :src="$translate('stabiloVueTheme::Single.DisposalIcon')" :alt="$translate('stabiloVueTheme::Single.DisposalHeadline')" class="img-fluid mr-2" />
                      {{ $translate("stabiloVueTheme::Single.DisposalHeadline") }}
                    </button>
                  </h2>
                  <i class="fa" :class="isAccordionOpen('disposal') ? 'fa-minus' : 'fa-plus'" aria-hidden="true"></i>
                </div>
                <div v-show="isAccordionOpen('disposal')" class="card-body px-0">
                  <div class="my-4" v-html="disposalText"></div>
                </div>
              </div>

              <div class="card">
                <div class="card-header d-flex justify-content-between align-items-center px-0" id="feedback-anchor" @click="toggleAccordion('feedback', $event)">
                  <h2 class="mb-0">
                    <button class="btn btn-link pl-0 font-weight-bold" type="button">
                      <img :src="$translate('stabiloVueTheme::Single.FeedbackIcon')" alt="Feedback" class="img-fluid mr-2" />
                      {{ $translate("stabiloVueTheme::Single.FeedbackHeadline") }}
                    </button>
                  </h2>
                  <i class="fa" :class="isAccordionOpen('feedback') ? 'fa-minus' : 'fa-plus'" aria-hidden="true"></i>
                </div>
                <div v-show="isAccordionOpen('feedback')" class="card-body px-0">
                  <feedback-container
                    class="discuss"
                    :options="{ allowFeedbacksOnlyIfPurchased: false, allowNoRatingFeedback: true, feedbacksPerPage: 10, numberOfFeedbacks: 1, timestampVisibility: true, allowGuestFeedbacks: true }"
                    classes=""
                    styles=""
                  >
                  </feedback-container>
                </div>
              </div>
              <slot name="add-detail-tabs-content"></slot>
            </div>
            <!-- ./ITEM DESCRIPTION -->
          </div>

          <div class="col-12 col-lg grid-3 mt-3">
            <div class="fs-xselling">
              <slot name="cross-selling-accessory"></slot>
            </div>

            <div class="col-12 mb-5 mb-md-0 d-flex align-items-center flex-wrap p-3 p-md-5 service">
              <div>
                <p class="h3 font-weight-bold font-heading mb-3" v-html="$translate('stabiloVueTheme::Homepage.Section15Headline')"></p>
                <p class="mb-3 mb-md-5 h4" v-html="$translate('stabiloVueTheme::Homepage.Section15Description')"></p>
                <div class="d-flex flex-column flex-lg-row flex-wrap justify-content-center justify-content-md-start mb-md-5 mb-lg-0">
                  <a :href="$translate('stabiloVueTheme::Homepage.Section15Link')" class="btn btn-custom d-flex align-items-center justify-content-center font-weight-bold">
                    <span v-html="$translate('stabiloVueTheme::Homepage.Section15LinkText')"></span>
                  </a>
                  <div class="mt-3 mt-lg-0 ml-lg-3 contact-info">
                    <p class="mb-0 times" v-html="$translate('stabiloVueTheme::Homepage.Section15OpeningTimes')"></p>
                    <p class="mb-0 font-weight-bold phone" v-html="$translate('stabiloVueTheme::Homepage.Section15Phone')"></p>
                    <p class="mb-0 font-weight-bold email" v-html="$translate('stabiloVueTheme::Homepage.Section15Email')"></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- <slot name="item-list-container"></slot> -->
        <slot name="feedback-container"></slot>

        <transition name="fs-sticky-cart-slide">
          <div class="fs-sticky-cart" v-if="showStickyCart" aria-label="In den Warenkorb">
            <div class="fs-sticky-cart__inner">
              <div class="fs-sticky-cart__thumb" aria-hidden="true">
                <div
                  class="fs-sticky-discount fs-discount-badge d-flex align-items-center justify-content-center text-white font-weight-bold position-absolute border-radius px-1 py-1"
                  v-if="savingMoneyPercent > 0"
                >
                  <span>-{{ savingMoneyPercent }}%</span>
                </div>
                <img
                  class="border-radius"
                  v-if="currentVariation.images && currentVariation.images.all && currentVariation.images.all.length"
                  :src="currentVariation.images.all[0].urlPreview || currentVariation.images.all[0].urlMiddle || currentVariation.images.all[0].url"
                  :alt="currentVariation | itemName"
                  loading="lazy"
                />
              </div>

              <div class="fs-sticky-cart__meta">
                <div class="fs-sticky-cart__title">{{ currentVariation | itemName }}</div>
                <div class="fs-sticky-cart__price">
                  <item-price :show-cross-price="false"></item-price>
                </div>
              </div>

              <div class="fs-sticky-cart__cta">
                <add-to-basket
                  :variation-id="currentVariation.variation.id"
                  :is-salable="!!currentVariation.filter && currentVariation.filter.isSalable"
                  :has-children="!!currentVariation.filter && currentVariation.filter.hasActiveChildren"
                  :interval-quantity="currentVariation.variation.intervalOrderQuantity || 1"
                  :minimum-quantity="currentVariation.variation.minimumOrderQuantity"
                  :maximum-quantity="
                    !!currentVariation.variation.maximumOrderQuantity && currentVariation.variation.maximumOrderQuantity > 0 ? currentVariation.variation.maximumOrderQuantity : null
                  "
                  :order-properties="
                    currentVariation.properties.filter(function(prop) {
                      return prop.property.isOderProperty;
                    })
                  "
                  :has-order-properties="currentVariation.hasOrderProperties"
                  :has-required-order-property="currentVariation.hasRequiredOrderProperty"
                  :use-large-scale="false"
                  :show-quantity="false"
                  :item-url="currentVariation | itemURL"
                  :is-variation-selected="isVariationSelected && currentVariation.filter.isSalable"
                  :has-price="currentVariation | hasItemDefaultPrice"
                >
                </add-to-basket>
              </div>
            </div>
          </div>
        </transition>
      </div>

      <div class="single container-fluid">
        <div ref="stickyNav" class="sticky-nav bg-white d-none d-xl-flex justify-content-between align-items-center" :class="{ 'is-sticky': isSticky }">
          <div class="container-max d-flex align-items-center justify-content-between">
            <span class="h4 font-weight-bold mb-0 px-0 py-3" :class="{ active: activeSection === 'similar' }" @click="scrollToSection('similar')">{{
              $translate("stabiloVueTheme::Single.LastSeenHeadline")
            }}</span>
            <span class="h4 font-weight-bold mb-0 px-0 py-3" :class="{ active: activeSection === 'service' }" @click="scrollToSection('service')">{{
              $translate("stabiloVueTheme::Single.ServiceHeadline")
            }}</span>
            <span class="h4 font-weight-bold mb-0 px-0 py-3" :class="{ active: activeSection === 'recommendation' }" @click="scrollToSection('recommendation')">{{
              $translate("stabiloVueTheme::Single.RecommendationHeadline")
            }}</span>
            <span class="h4 font-weight-bold mb-0 px-0 py-3" :class="{ active: activeSection === 'search' }" @click="scrollToSection('search')" v-if="searchTerms && searchTerms.length > 0">{{
              $translate("stabiloVueTheme::Single.SearchHeadline")
            }}</span>
            <div class="sticky-price">
              <item-price :show-cross-price="isRecommendedPriceActive" :shipping-preview="activeShippingPreview"></item-price>
            </div>
            <add-to-basket
              :variation-id="currentVariation.variation.id"
              :is-salable="!!currentVariation.filter && currentVariation.filter.isSalable"
              :has-children="!!currentVariation.filter && currentVariation.filter.hasActiveChildren"
              :interval-quantity="currentVariation.variation.intervalOrderQuantity || 1"
              :minimum-quantity="currentVariation.variation.minimumOrderQuantity"
              :maximum-quantity="!!currentVariation.variation.maximumOrderQuantity && currentVariation.variation.maximumOrderQuantity > 0 ? currentVariation.variation.maximumOrderQuantity : null"
              :order-properties="
                currentVariation.properties.filter(function(prop) {
                  return prop.property.isOderProperty;
                })
              "
              :has-order-properties="currentVariation.hasOrderProperties"
              :has-required-order-property="currentVariation.hasRequiredOrderProperty"
              :use-large-scale="false"
              :show-quantity="true"
              :item-url="currentVariation | itemURL"
              :is-variation-selected="isVariationSelected && currentVariation.filter.isSalable"
              :has-price="currentVariation | hasItemDefaultPrice"
            >
            </add-to-basket>
          </div>
        </div>

        <div class="container-max mt-5">
          <div class="row position-relative">
            <div class="col-12 mb-5">
              <div class="fs-xselling similar">
                <p class="h3 title font-weight-bold font-heading mb-3">{{ $translate("stabiloVueTheme::Single.LastSeenHeadline") }}</p>
                <slot name="item-list-container"></slot>
                <slot name="cross-selling-similar"></slot>
              </div>
            </div>
            <div class="col-12 mb-5">
              <div class="row service-finder">
                <p class="col-12 h3 title font-weight-bold font-heading mb-3">{{ $translate("stabiloVueTheme::Single.ServiceHeadline") }}</p>
                <div class="col-12 col-md-6 mb-5 mb-md-0 d-flex align-items-center flex-wrap">
                  <div class="p-3 p-md-5 service">
                    <p class="h3 font-weight-bold font-heading mb-3" v-html="$translate('stabiloVueTheme::Homepage.Section15Headline')"></p>
                    <p class="mb-3 mb-md-5 h4" v-html="$translate('stabiloVueTheme::Homepage.Section15Description')"></p>
                    <div class="d-flex flex-column flex-lg-row flex-wrap justify-content-center justify-content-md-start mb-md-5 mb-lg-0">
                      <a :href="$translate('stabiloVueTheme::Homepage.Section15Link')" class="btn btn-custom d-flex align-items-center justify-content-center font-weight-bold p-4">
                        <span v-html="$translate('stabiloVueTheme::Homepage.Section15LinkText')"></span>
                      </a>
                      <div class="mt-3 mt-lg-0 ml-lg-3 contact-info">
                        <p class="mb-0 times" v-html="$translate('stabiloVueTheme::Homepage.Section15OpeningTimes')"></p>
                        <p class="mb-0 font-weight-bold phone" v-html="$translate('stabiloVueTheme::Homepage.Section15Phone')"></p>
                        <p class="mb-0 font-weight-bold email" v-html="$translate('stabiloVueTheme::Homepage.Section15Email')"></p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-6 mb-5 mb-md-0 d-flex flex-wrap align-items-stretch align-items-lg-center">
                  <div class="p-3 p-md-5 finder">
                    <p class="h3 font-weight-bold font-heading mb-3 text-white" v-html="$translate('stabiloVueTheme::Single.FinderHeadline')"></p>
                    <p class="mb-3 mb-md-5 h4 text-white" v-html="$translate('stabiloVueTheme::Single.FinderDescription')"></p>
                    <div class="d-flex flex-column flex-lg-row flex-wrap justify-content-center justify-content-md-start mb-md-5 mb-lg-0">
                      <a :href="$translate('stabiloVueTheme::Single.FinderLink')" class="btn btn-custom d-flex align-items-center justify-content-start font-weight-bold p-4">
                        <span v-html="$translate('stabiloVueTheme::Single.FinderLinkText')"></span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 mb-5">
              <div class="row recommendation">
                <div class="nosto_element" id="frontpage-nosto-1"></div>
              </div>
            </div>
            <div class="col-12 mb-5" v-if="searchTerms && searchTerms.length > 0">
              <div class="row search-sugg">
                <p class="h3 title font-weight-bold font-heading w-100 mb-3">{{ $translate("stabiloVueTheme::Single.SearchHeadline") }}</p>
                <template v-for="(search, idx) in searchTerms">
                  <a :class="'px-3 py-1 mb-3' + (idx < searchTerms.length - 1 ? ' mr-3' : '')" :key="idx" :href="`/search/?query=${search.trim()}`">{{ search.trim() }}</a>
                </template>
              </div>
            </div>
            <div class="col-12 recommendation-6">
              <div id="productpage-nosto-6" class="nosto_element" data-nosto-ref='{"ref":"productpage-nosto-6"}'></div>
            </div>
          </div>
        </div>
      </div>
      <div class="fs-homepage my-5">
        <div
          class="section-13 newsletter py-5"
          :style="{ '--newsletter-bg': `url('${$translate('stabiloVueTheme::Homepage.Section13NewsletterImage')}')` }"
        >
          <div class="newsletter__media" aria-hidden="true"></div>
          <div class="container-max">
            <div class="newsletter__layout">
              <div class="newsletter__content">
                <div class="newsletter__content-inner">
                  <p class="h3 font-weight-bold font-heading mb-3" v-html="$translate('stabiloVueTheme::Homepage.Section13NewsletterHeadline')"></p>
                  <p class="mb-4" v-html="$translate('stabiloVueTheme::Homepage.Section13NewsletterDescription')"></p>
                  <form class="layout_form cr_form cr_font mb-0" action="https://mailings.stabilo-fachmarkt.de/f/47330-72007/wcs/" method="post" target="_blank">
                    <div class="cr_body cr_page cr_font formbox">
                      <div class="non_sortable"></div>
                      <div class="editable_content">
                        <div id="1605817" rel="email" class="cr_ipe_item ui-sortable musthave">
                          <div class="d-flex flex-column flex-lg-row align-items-center justify-content-start mb-3">
                            <input id="text1605817" name="email" value="" type="text" class="input px-3 py-2" placeholder="E-Mail Adresse eingeben" />
                            <label for="text1605817" class="itemname"></label>
                            <div id="3552319" rel="button" class="cr_ipe_item ui-sortable submit_container d-inline ml-lg-3">
                              <button type="submit" class="cr_button btn btn-custom d-flex align-items-center justify-content-center font-weight-bold p-4 mb-1">Absenden</button>
                            </div>
                          </div>
                          <div>
                            <label class="d-flex align-items-start">
                              <input type="checkbox" name="chbox" id="chbox" required class="mt-1" />
                              <span class="text-dark ml-2" v-html="$translate('stabiloVueTheme::Homepage.Section13NewsletterLegal')"></span>
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="single container-fluid">
        <div class="container-max mt-5">
          <div class="row position-relative">    
            <div class="col-12 client">
              <div class="row">
                <div class="col-12 px-3 px-md-0 d-block">
                  <p class="h3 title font-weight-bold font-heading w-100 mb-3">{{ $translate("stabiloVueTheme::Homepage.Section9Headline") }}</p>
                </div>
                <div class="col-12 swiper myBadgeSwiper mb-3 px-0">
                  <div class="swiper-wrapper d-flex justify-content-between">
                    <template v-for="i in 5">
                      <template v-if="$translate('stabiloVueTheme::Homepage.Section9Trust' + i + 'Img')">
                        <div class="swiper-slide d-flex badge position-relative pt-3 justify-content-center mr-md-3" :key="i">
                          <a :href="$translate('stabiloVueTheme::Homepage.Section9Trust' + i + 'Link')" target="_blank" class="trust d-flex align-items-center justify-content-center w-100">
                            <div class="gradient-overlay"></div>
                            <img
                              :src="$translate('stabiloVueTheme::Homepage.Section9Trust' + i + 'Img')"
                              :alt="$translate('stabiloVueTheme::Homepage.Section9Trust' + i + 'Heading')"
                              class="img-fluid"
                            />
                            <p class="wrap font-weight-bold h3 text-dark text-center font-heading">{{ $translate("stabiloVueTheme::Homepage.Section9Trust" + i + "Heading") }}</p>
                          </a>
                        </div>
                      </template>
                    </template>
                  </div>
                  <div class="swiper-pagination d-md-none"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </slot>
  </div>
</template>

<script>
import { get } from "../../helper/get";
import { isNullOrUndefined } from "../../helper/utils";

export default {
  name: "single-item",

  props: {
    pleaseSelectOptionVariationId: {
      type: Number,
      default: 0,
    },
    initPleaseSelectOption: {
      type: Boolean,
      default: false,
    },
    showNetPrices: {
      type: Boolean,
      default: false,
    },
    isWishListEnabled: {
      type: Boolean,
      default: false,
    },
    itemId: {
      type: Number,
      required: true,
    },
    shippingPreview: {
      type: [Object, String],
      default: null,
    },
    afterKey: Object,
  },

  jsonDataFields: ["itemData", "attributesData", "variations"],

  provide() {
    return {
      itemId: this.$props.itemId,
    };
  },

  data() {
    return {
      openAccordions: {
        description: true,
        technical: false,
        assessments: false,
        manufacturer: false,
        disposal: false,
        feedback: false,
      },
      isSticky: false,
      activeSection: "similar",
      buyboxCtaInView: true,
      buyboxCtaAboveViewport: false,
      stickyCartFallbackHandler: null,
      stickyCartFallbackRafId: null,
      showEnergyLabelModal: false,
    };
  },

  computed: {
    canUseStickyCart() {
      const variation = this.currentVariation;
      return !!(variation && variation.filter && variation.filter.isSalable && variation.item && variation.item.itemType !== "set");
    },

    showStickyCart() {
      return this.canUseStickyCart && this.buyboxCtaAboveViewport;
    },

    itemConfig() {
      return App.config.item.itemData;
    },

    isDescriptionTabActive() {
      return (App.config.item.itemData.includes("item.description") || App.config.item.itemData.includes("all")) && !!this.currentVariation.texts.description.length;
    },

    isManufacturerTabShown() {
      return (
        this.currentVariation.item.manufacturer.url !== "" ||
        this.currentVariation.item.manufacturer.street !== "" ||
        this.currentVariation.item.manufacturer.houseNo !== "" ||
        this.currentVariation.item.manufacturer.postcode !== "" ||
        this.currentVariation.item.manufacturer.town !== "" ||
        this.currentVariation.item.manufacturer.countryId !== 0 ||
        this.currentVariation.item.manufacturer.phoneNumber !== "" ||
        this.currentVariation.item.manufacturer.faxNumber !== "" ||
        this.currentVariation.item.manufacturer.email !== "" ||
        this.currentVariation.item.manufacturer.legalName !== "" ||
        this.currentVariation.item.manufacturer.contactUrl !== "" ||
        this.currentVariation.item.manufacturer.name !== "" ||
        this.currentVariation.item.manufacturer.externalName !== "" ||
        // Bedingungen aus isEuResponsibleTabShown anhängen:
        this.currentVariation.item.manufacturer.responsibleEmail !== "" ||
        this.currentVariation.item.manufacturer.responsibleHouseNo !== "" ||
        this.currentVariation.item.manufacturer.responsibleName !== "" ||
        this.currentVariation.item.manufacturer.responsiblePhoneNo !== "" ||
        this.currentVariation.item.manufacturer.responsiblePostCode !== "" ||
        this.currentVariation.item.manufacturer.responsibleStreet !== "" ||
        this.currentVariation.item.manufacturer.responsibleTown !== "" ||
        this.currentVariation.item.manufacturer.responsibleContactUrl !== "" ||
        this.currentVariation.item.manufacturer.responsibleCountry !== 0
      );
    },

    isRecommendedPriceActive() {
      return App.config.item.itemData.includes("item.recommendedPrice") || App.config.item.itemData.includes("all");
    },

    isShortDescriptionActive() {
      return App.config.item.itemData.includes("item.shortDescription") || App.config.item.itemData.includes("all");
    },

    isTechnicalDataTabActive() {
      return (App.config.item.itemData.includes("item.technical_data") || App.config.item.itemData.includes("all")) && !!this.currentVariation.texts.technicalData.length;
    },

    disposalText() {
      if (!this.currentVariation.variationProperties) return "";
      let value = "";
      this.currentVariation.variationProperties.forEach((group) => {
        (group.properties || []).forEach((prop) => {
          if (prop.id === 299 && prop.values && prop.values.value) {
            value = prop.values.value;
          }
        });
      });
      return value && value.trim ? value.trim() : value;
    },

    hasFeedback() {
      return this.currentVariation && this.currentVariation.item && this.currentVariation.item.feedbackCount > 0;
    },

    variationGroupedProperties() {
      return this.$store.getters[`${this.itemId}/variationGroupedProperties`];
    },

    variationMissingProperties() {
      return this.$store.getters[`${this.itemId}/variationMissingProperties`];
    },

    currentVariation() {
      return get(this.$store.state, `items[${this.itemId}].variation.documents[0].data`);
    },

    activeShippingPreview() {
      const preview = this.resolveShippingPreview();

      if (!preview || typeof preview !== "object" || Object.keys(preview).length === 0) {
        return null;
      }

      const previewVariationId = Number(preview.variationId || 0);
      const currentVariationId = Number(this.currentVariation?.variation?.id || 0);

      if (previewVariationId && currentVariationId && previewVariationId !== currentVariationId) {
        return null;
      }

      return preview;
    },

    isVariationSelected() {
      return get(this.$store.state, `items[${this.itemId}].variationSelect.isVariationSelected`);
    },

    attributes() {
      return get(this.$store.state, `items[${this.itemId}].variationSelect.attributes`);
    },

    units() {
      return get(this.$store.state, `items[${this.itemId}].variationSelect.units`);
    },

    isItemSet() {
      return this.$store.state.items.isItemSet;
    },

    hasSpeditionDelivery() {
      if (!this.currentVariation.variationProperties) return false;
      return this.currentVariation.variationProperties.some((group) => group.properties && group.properties.some((prop) => prop.id === 40));
    },

    searchTerms() {
      const result = [];
      const vps = this.currentVariation.variationProperties || [];
      vps.forEach((group) => {
        (group.properties || []).forEach((prop) => {
          if (prop.id === 267 && prop.values && prop.values.value) {
            result.push(
              ...prop.values.value
                .split(";")
                .map((s) => s.trim())
                .filter(Boolean)
            );
          }
        });
      });
      return result;
    },

    energyLabelValue() {
      // Eigenschaft ID 9
      let value = "";
      if (this.currentVariation.variationProperties) {
        this.currentVariation.variationProperties.forEach((group) => {
          (group.properties || []).forEach((prop) => {
            if (prop.id === 9 && prop.values && prop.values.value) {
              value = prop.values.value.trim();
            }
          });
        });
      }
      return value;
    },
    energyLabelType() {
      // Eigenschaft ID 8
      let type = "";
      if (this.currentVariation.variationProperties) {
        this.currentVariation.variationProperties.forEach((group) => {
          (group.properties || []).forEach((prop) => {
            if (prop.id === 8 && prop.values && prop.values.value) {
              type = prop.values.value.trim().toLowerCase();
            }
          });
        });
      }
      return type;
    },
    energyLabelImage() {
      if (!this.energyLabelValue || !this.energyLabelType) return null;
      if (this.energyLabelType === "lampen") {
        return this.$translate(`stabiloVueTheme::EnergyLabel.Lampen${this.energyLabelValue.replace("+", "plus").replace("++", "plusplus")}`);
      }
      if (this.energyLabelType === "eek20210301") {
        // Key immer klein schreiben
        const valueKey = this.energyLabelValue.toLowerCase();
        return this.$translate(`stabiloVueTheme::EnergyLabel.EEK20210301${valueKey}`);
      }
      return null;
    },
    energyLabelModalImage() {
      // Eigenschaft ID 10
      let img = "";
      if (this.currentVariation.variationProperties) {
        this.currentVariation.variationProperties.forEach((group) => {
          (group.properties || []).forEach((prop) => {
            if (prop.id === 10 && prop.values && prop.values.value) {
              img = prop.values.value.trim();
            }
          });
        });
      }
      return img;
    },

    savingMoneyPercent() {
      let oldPrice = 0;
      let newPrice = 0;

      if (this.currentVariation.prices.specialOffer && this.currentVariation.prices.default) {
        oldPrice = this.currentVariation.prices.default.unitPrice.value;
        newPrice = this.currentVariation.prices.specialOffer.unitPrice.value;
      } else if (this.currentVariation.prices.rrp && this.currentVariation.prices.default) {
        oldPrice = this.currentVariation.prices.rrp.unitPrice.value;
        newPrice = this.currentVariation.prices.default.unitPrice.value;
      }

      if (oldPrice > 0 && newPrice > 0 && oldPrice > newPrice) {
        return Math.floor(((oldPrice - newPrice) / oldPrice) * 100);
      }

      return 0;
    },
  },

  created() {
    this.$store.dispatch("initVariation", this.itemData);
    this.$store.commit(`${this.itemId}/setPleaseSelectVariationId`, this.pleaseSelectOptionVariationId);
  },

  mounted() {
    this.$nextTick(() => {
      this.$store.dispatch(`${this.itemId}/variationSelect/setVariationSelect`, {
        itemId: this.itemId,
        attributes: this.attributesData,
        variations: this.variations,
        initialVariationId: this.currentVariation.variation.id,
        isPleaseSelectOption: this.initPleaseSelectOption,
        afterKey: this.afterKey,
      });

      if (this.isItemSet) {
        this.$store.dispatch("initSetComponents", this.itemData);
      }
    });

    if (this.hasFeedback) {
      this.openAccordions.feedback = true;
    }

    // listen for variation change to hydrate all children lazy-hydrate components
    document.addEventListener("onVariationChanged", () => this.hydrateChildren(this.$children));
    this.initStickyNav();
    this.initStickyCartTrigger();
  },

  beforeDestroy() {
    this.destroyStickyCartTrigger();
  },

  methods: {
    updateBuyboxViewportState() {
      if (typeof window === "undefined") {
        return;
      }

      const buyboxEl = this.$refs.buyboxCta;
      const sentinelEl = this.$refs.buyboxCtaSentinel;
      const triggerEl = sentinelEl || buyboxEl;

      if (!triggerEl) {
        return;
      }

      const targetRect = triggerEl.getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

      if (buyboxEl) {
        const buyboxRect = buyboxEl.getBoundingClientRect();
        this.buyboxCtaInView = buyboxRect.bottom > 0 && buyboxRect.top < viewportHeight;
      } else {
        this.buyboxCtaInView = targetRect.bottom > 0 && targetRect.top < viewportHeight;
      }

      this.buyboxCtaAboveViewport = targetRect.top <= 0;
    },

    initStickyCartTrigger() {
      if (typeof window === "undefined") {
        return;
      }

      const buyboxEl = this.$refs.buyboxCta;
      const sentinelEl = this.$refs.buyboxCtaSentinel;

      if (!buyboxEl && !sentinelEl) {
        return;
      }

      this.stickyCartFallbackHandler = () => {
        if (this.stickyCartFallbackRafId) {
          return;
        }

        this.stickyCartFallbackRafId = window.requestAnimationFrame(() => {
          this.stickyCartFallbackRafId = null;
          this.updateBuyboxViewportState();
        });
      };

      window.addEventListener("scroll", this.stickyCartFallbackHandler, { passive: true });
      window.addEventListener("resize", this.stickyCartFallbackHandler);
      window.addEventListener("orientationchange", this.stickyCartFallbackHandler);

      this.stickyCartFallbackHandler();
      window.setTimeout(() => this.updateBuyboxViewportState(), 0);
    },

    destroyStickyCartTrigger() {
      if (typeof window !== "undefined" && this.stickyCartFallbackHandler) {
        window.removeEventListener("scroll", this.stickyCartFallbackHandler);
        window.removeEventListener("resize", this.stickyCartFallbackHandler);
        window.removeEventListener("orientationchange", this.stickyCartFallbackHandler);
        this.stickyCartFallbackHandler = null;
      }

      if (typeof window !== "undefined" && this.stickyCartFallbackRafId) {
        window.cancelAnimationFrame(this.stickyCartFallbackRafId);
        this.stickyCartFallbackRafId = null;
      }
    },

    resolveShippingPreview() {
      if (this.shippingPreview && typeof this.shippingPreview === "object") {
        return this.shippingPreview;
      }

      if (typeof this.shippingPreview !== "string" || this.shippingPreview.length === 0 || typeof document === "undefined") {
        return null;
      }

      const element = document.getElementById(this.shippingPreview);

      if (!element) {
        return null;
      }

      try {
        return JSON.parse(element.textContent);
      } catch (_) {
        return null;
      }
    },

    toggleAccordion(section, event) {
      const isCurrentlyOpen = this.isAccordionOpen(section);

      // Store the target element before any async operations
      const targetElement = event.currentTarget ? event.currentTarget.closest(".card") : null;

      // Toggle accordion state for the clicked section only
      this.openAccordions[section] = !isCurrentlyOpen;

      // If accordion is being opened, scroll to it after a short delay
      if (!isCurrentlyOpen && targetElement) {
        this.$nextTick(() => {
          setTimeout(() => {
            targetElement.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
          }, 100); // Small delay to ensure accordion animation starts
        });
      }
    },

    isAccordionOpen(section) {
      return !!this.openAccordions[section];
    },

    getDataField(field) {
      return get(this.currentVariation, field);
    },

    getFilteredDataField(field, filter) {
      if (!isNullOrUndefined(this.$options.filters[filter])) {
        return this.$options.filters[filter](this.getDataField(field));
      }

      return this.getDataField(field);
    },

    // iterate recursively the children components and call their hydrate method, if it is a lazy-hydrate component
    hydrateChildren(nodes) {
      nodes.forEach((component) => {
        if (component.$options.name === "lazy-hydrate") {
          component.hydrate();
        } else if (component.$children.length) {
          this.hydrateChildren(component.$children);
        }
      });
    },
    initStickyNav() {
      const sections = {
        similar: this.$el.querySelector(".fs-xselling.similar"),
        service: this.$el.querySelector(".service-finder"),
        recommendation: this.$el.querySelector(".recommendation"),
        search: this.$el.querySelector(".search"),
      };
      const stickyNav = this.$refs.stickyNav;
      const onScroll = () => {
        const navTop = stickyNav.getBoundingClientRect().top;
        this.isSticky = navTop <= 0;
        let found = false;
        for (const key in sections) {
          const section = sections[key];
          if (section) {
            const rect = section.getBoundingClientRect();
            if (rect.top <= 80 && rect.bottom > 80 && !found) {
              this.activeSection = key;
              found = true;
            }
          }
        }
      };
      window.addEventListener("scroll", onScroll);
      this.$once("hook:beforeDestroy", () => {
        window.removeEventListener("scroll", onScroll);
      });
    },
    scrollToSection(sectionKey) {
      const sections = {
        similar: this.$el.querySelector(".fs-xselling.similar"),
        service: this.$el.querySelector(".service-finder"),
        recommendation: this.$el.querySelector(".recommendation"),
        search: this.$el.querySelector(".search"),
      };
      const section = sections[sectionKey];
      if (section) {
        section.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    },
  },
};
</script>
